module.exports = __webpack_public_path__ + "static/media/IMG_8227.ba64defd.JPG";